import { ExtractionHpReport } from "../../shared/reports/ExtractionHpReport";
import { LotReleaseReport } from "../../shared/reports/LotReleaseReport";
import { NonConformityReport } from "../../shared/reports/NonConformityReport";
import { ProductionControlReport } from "../../shared/reports/ProductionControlReport";
import { YieldReport } from "../../shared/reports/YieldReport";

export function renderSpecialControlSection(view, sectionKey) {
    const { updateCommentaire, updateMeta, uploadAttachments, workspace } = view;
    switch (sectionKey) {
        case "nonConformites":
            return (
                <NonConformityReport
                    meta={workspace.formData.meta || {}}
                    onMetaChange={updateMeta}
                    dateProduction={workspace.activeDossier.dateProduction}
                    value={workspace.formData.commentaires?.nonConformites || {}}
                    onChange={(value) => updateCommentaire("nonConformites", value)}
                />
            );
        case "controleProduction":
            return (
                <ProductionControlReport
                    value={workspace.formData.commentaires?.controleProduction || {}}
                    onChange={(value) => updateCommentaire("controleProduction", value)}
                />
            );
        case "liberationLot":
            return (
                <LotReleaseReport
                    activeDossier={workspace.activeDossier}
                    selectedEhpad={workspace.selectedEhpad}
                    meta={workspace.formData.meta || {}}
                    value={workspace.formData.commentaires?.liberationLot || {}}
                    onChange={(value) => updateCommentaire("liberationLot", value)}
                />
            );
        case "rendement":
            return (
                <YieldReport
                    value={workspace.formData.commentaires?.rendement || {}}
                    onChange={(value) => updateCommentaire("rendement", value)}
                />
            );
        case "extractionHp":
            return (
                <ExtractionHpReport
                    uploading={workspace.attachmentUploading}
                    onUpload={uploadAttachments}
                />
            );
        default:
            return null;
    }
}
